/**
 * An iframe element that uses the iframeResizer library to scale automatically.
 */
import iFrameResizer from 'iframe-resizer';

const iframe = (iframeElement, iframeResizerOptions = {}) => {
  iFrameResizer.iframeResizer(iframeResizerOptions, iframeElement);

  return {
    destroy: () => iframeElement.iFrameResizer.close(),
  };
};

export default iframe;
